/* eslint-disable consistent-return */
class LieuxApi {
  async list(accessToken) {
    const resp = await fetch(`${process.env.REACT_APP_API_URL}/api/lieux`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` }
    });
    const json = await resp.json();
    return Promise.resolve(json.data);
  }

  async get(id, accessToken) {
    const resp = await fetch(`${process.env.REACT_APP_API_URL}/api/lieux/${id}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` }
    });
    const json = await resp.json();
    return Promise.resolve(json.data);
  }

  async create(payload, accessToken) {
    const resp = await fetch(`${process.env.REACT_APP_API_URL}/api/lieux/create`, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` }
    });
    return await resp.json();
  }

  async update(id, payload, accessToken) {
    const resp = await fetch(`${process.env.REACT_APP_API_URL}/api/lieux/update`, {
      method: 'POST',
      body: JSON.stringify({ ...payload, id }),
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` }
    });
    return await resp.json();
  }

  async remove(id, accessToken) {
    const resp = await fetch(`${process.env.REACT_APP_API_URL}/api/lieux/delete`, {
      method: 'POST',
      body: JSON.stringify({ id }),
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` }
    });
    return await resp.json();
  }

  // ── Évaluation interne (questionnaire de conformité FOR-DR-003) ──

  /** L'évaluation d'un lieu, et les libellés des onze critères. */
  async audit(lieuId, accessToken) {
    const resp = await fetch(`${process.env.REACT_APP_API_URL}/api/lieux/${lieuId}/audit`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` }
    });
    const json = await resp.json();
    return Promise.resolve({ criteres: (json && json.criteres) || {}, data: (json && json.data) || null });
  }

  async saveAudit(payload, accessToken) {
    const resp = await fetch(`${process.env.REACT_APP_API_URL}/api/lieux/audit/save`, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` }
    });
    return await resp.json();
  }

  /** Le document Word, renvoyé en base64. */
  async auditDocument(lieuId, accessToken) {
    const resp = await fetch(`${process.env.REACT_APP_API_URL}/api/lieux/${lieuId}/audit/document`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` }
    });
    return await resp.json();
  }

  /** Envoie la grille au lieu, a l'adresse portee par sa fiche. */
  async envoyerAudit(lieuId, accessToken) {
    const resp = await fetch(`${process.env.REACT_APP_API_URL}/api/lieux/audit/envoyer`, {
      method: 'POST',
      body: JSON.stringify({ lieu_id: lieuId }),
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` }
    });
    return await resp.json();
  }

  /**
   * La grille vue par le lieu, sans jeton de connexion.
   *
   * Le lien recu par courriel est la seule preuve d'identite : l'exploitant
   * n'a pas de compte sur le CRM, et ne doit pas avoir a en creer un.
   */
  async publicAudit(token) {
    const resp = await fetch(`${process.env.REACT_APP_API_URL}/api/public/evaluation-lieu/${token}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });
    return await resp.json();
  }

  async publicAuditSubmit(token, payload) {
    const resp = await fetch(`${process.env.REACT_APP_API_URL}/api/public/evaluation-lieu/${token}`, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: { 'Content-Type': 'application/json' }
    });
    return await resp.json();
  }

  // ── Prestations annexes ──

  async prestations(lieuId, accessToken) {
    const resp = await fetch(`${process.env.REACT_APP_API_URL}/api/lieux/${lieuId}/prestations`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` }
    });
    const json = await resp.json();
    return Promise.resolve(json.data);
  }

  async createPrestation(payload, accessToken) {
    const resp = await fetch(`${process.env.REACT_APP_API_URL}/api/lieux/prestations/create`, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` }
    });
    return await resp.json();
  }

  async removePrestation(lieuId, id, accessToken) {
    const resp = await fetch(`${process.env.REACT_APP_API_URL}/api/lieux/prestations/delete`, {
      method: 'POST',
      body: JSON.stringify({ lieu_id: lieuId, id }),
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` }
    });
    return await resp.json();
  }

  // ── Évaluations internes ──

  async evaluations(lieuId, accessToken) {
    const resp = await fetch(`${process.env.REACT_APP_API_URL}/api/lieux/${lieuId}/evaluations`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` }
    });
    const json = await resp.json();
    return Promise.resolve(json.data);
  }

  async createEvaluation(payload, accessToken) {
    const resp = await fetch(`${process.env.REACT_APP_API_URL}/api/lieux/evaluations/create`, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` }
    });
    return await resp.json();
  }

  async removeEvaluation(lieuId, id, accessToken) {
    const resp = await fetch(`${process.env.REACT_APP_API_URL}/api/lieux/evaluations/delete`, {
      method: 'POST',
      body: JSON.stringify({ lieu_id: lieuId, id }),
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` }
    });
    return await resp.json();
  }

  // ── Litiges ──

  async litiges(lieuId, accessToken) {
    const resp = await fetch(`${process.env.REACT_APP_API_URL}/api/lieux/${lieuId}/litiges`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` }
    });
    const json = await resp.json();
    return Promise.resolve(json.data);
  }

  async createLitige(payload, accessToken) {
    const resp = await fetch(`${process.env.REACT_APP_API_URL}/api/lieux/litiges/create`, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` }
    });
    return await resp.json();
  }

  async resolveLitige(lieuId, id, resolution, accessToken) {
    const resp = await fetch(`${process.env.REACT_APP_API_URL}/api/lieux/litiges/resolve`, {
      method: 'POST',
      body: JSON.stringify({ lieu_id: lieuId, id, resolution }),
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` }
    });
    return await resp.json();
  }

  async removeLitige(lieuId, id, accessToken) {
    const resp = await fetch(`${process.env.REACT_APP_API_URL}/api/lieux/litiges/delete`, {
      method: 'POST',
      body: JSON.stringify({ lieu_id: lieuId, id }),
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` }
    });
    return await resp.json();
  }
}

export const lieuxApi = new LieuxApi();
